import { Box, Divider, Typography } from '@material-ui/core'
import currency from 'currency.js'
import React from 'react'
import styled from 'styled-components'

import PriceBreakdown from '../checkout/PriceBreakdown'
import CartMenuItemList from './CartMenuItemList'

const CartContainer = styled.div`
  padding-top: 16px;
`

export const OrderCart = ({
  cart: { itemSubTotal, orderItems },
  deleteMenuItem,
  isCartSaving,
  dropoffId,
  editMenuItem,
  isLoadingOrderForEdit,
  isEditingPastOrder,
}) => (
  <CartContainer>
    <Typography color="textSecondary" gutterBottom variant="overline">
      Your order
    </Typography>
    <CartMenuItemList
      deleteMenuItem={deleteMenuItem}
      isDeletingMenuItem={isCartSaving}
      dropoffId={dropoffId}
      editable
      editMenuItem={editMenuItem}
      isEditingMenuItem={isLoadingOrderForEdit}
      isEditingPastOrder={isEditingPastOrder}
      menuItems={orderItems}
      showEditLinks
      useFullSubTotal
    />
    <Box marginBottom={2} marginTop={3}>
      <Divider />
    </Box>
    <Box display="flex" justifyContent="space-between">
      <Typography variant="h5">Meal Total</Typography>
      <Typography variant="h5">
        {currency(itemSubTotal, { formatWithSymbol: true }).format()}
      </Typography>
    </Box>
  </CartContainer>
)

export const CheckoutCart = ({
  cart: { foodsbyFee, orderItems, orderTotal, preTaxSubTotal, taxSubTotal, taxSubtotal }, //again, need to support but subTotal spellings :(
  couponUsage,
  creditUsage,
  deleteMenuItem,
  isCartSaving,
  dropoffId,
  editMenuItem,
  isLoadingOrderForEdit,
  isEditingPastOrder,
  programUsage = {},
  storedCurrencyUsage = {},
}) => {
  return (
    <CartContainer>
      <Typography color="textSecondary" gutterBottom variant="overline">
        Your order
      </Typography>
      <CartMenuItemList
        deleteMenuItem={deleteMenuItem}
        isDeletingMenuItem={isCartSaving}
        dropoffId={dropoffId}
        editable
        editMenuItem={editMenuItem}
        isEditingMenuItem={isLoadingOrderForEdit}
        isEditingPastOrder={isEditingPastOrder}
        menuItems={orderItems}
        showEditLinks
        useFullSubTotal
      />
      <Box marginY={3}>
        <Divider />
      </Box>
      <PriceBreakdown
        couponAmount={couponUsage.couponAmount}
        couponApplied={!couponUsage.isEpp && couponUsage.couponApplied}
        couponCode={couponUsage.couponCode}
        creditsApplied={creditUsage.creditsApplied}
        creditsUsed={creditUsage.creditBalanceUsed}
        deliveryFee={foodsbyFee}
        subtotal={preTaxSubTotal}
        programAmount={programUsage?.programAmount || couponUsage.couponAmount}
        programApplied={
          programUsage?.programApplied || (couponUsage.couponApplied && couponUsage.isEpp)
        }
        programCode={programUsage?.programName || couponUsage.couponCode}
        storedCurrencyAmount={storedCurrencyUsage?.storedCurrencyBalanceUsed}
        storedCurrencyApplied={storedCurrencyUsage?.storedCurrencyApplied}
        taxes={taxSubTotal || taxSubtotal}
        orderTotal={orderTotal}
      />
    </CartContainer>
  )
}
